import React from 'react'
import { Table, TableProps } from 'antd'
import { Link } from "react-router-dom";



export default function StudyList() {
   
  
    const columns: TableProps<DataType>["columns"] = [
      {
        title: "Patient Name",
        dataIndex: "patientName",
        key: "pateintName",
      },
      {
        title: "MRN",
        dataIndex: "mrn",
        key: "mrn",
        // Link to the report page
        render: (text) => <Link to={`/editor/${text}`}>{text}</Link>,
      },
      {
        title: "Modality",
        dataIndex: "modality",
        key: "modality",
      },
      {
        title: "Accesion",
        dataIndex: "accesion",
        key: "accesion",
      },
    ];
    interface DataType {
      key: string;
      patientName: string;
      mrn: number;
      modality: string;
      accesion: number;
    }
  
    const data: DataType[] = [
      {
        key: "1",
        patientName: "Doe, Peter",
        mrn: 988902234,
        modality: "CT",
        accesion: 2,
      },
    ];
    
  return (
    <div>
        <h1>Study List</h1>
        <Table columns={columns} dataSource={data} />
    </div>
  )
}
